'use client';

import { FC } from 'react';

import { Button, Modal } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { NAVIGATION_MODAL_ZINDEX } from '@telialt/common-constants/src/modal';

import { PLAN_CARD_TEST_ID } from '../constants';
import { useDescriptionModalControls } from '../hooks/useDescriptionModalControls';
import { PlanCardModel } from '../model';

export const DescriptionModal: FC<{ descriptions: PlanCardModel.Description[] }> = ({ descriptions }) => {
    const { isDescriptionModalOpen, closeDescriptionModal, id } = useDescriptionModalControls();
    const { t } = useTranslations();
    const description = descriptions?.find((d) => d.id === id);
    const modal = description?.modal;

    return (
        <Modal open={isDescriptionModalOpen} onOpenChange={(open) => !open && closeDescriptionModal()}>
            <Modal.Content
                title={description?.term}
                actions={
                    <Button variant="primary" onClick={() => closeDescriptionModal()}>
                        {t['common.button.close']}
                    </Button>
                }
                stickyButtons={true}
                image={!!modal?.imageUrl && <img src={modal.imageUrl} alt={modal.imageAlt} />}
                closeButtonAriaLabel={t['common.button.close']}
                showCloseButton={true}
                data-test={PLAN_CARD_TEST_ID.DESCRIPTION_MODAL}
                zIndex={NAVIGATION_MODAL_ZINDEX}
            >
                {modal?.content}
            </Modal.Content>
        </Modal>
    );
};
